/* eslint-disable import/no-anonymous-default-export */
class EducationalInstitutes {
    educational_institutes: any;
    
    constructor(educational_institutes: any) {
      this.educational_institutes = educational_institutes
    }
  }
  
  export default function (educational_institutes: any) {
    return new EducationalInstitutes(educational_institutes)
  }
  